<template>
    <b-modal
        size="md"
        v-model="modalShow"
        title="管理用タグ（法人）の編集"
        @ok="handleOk"
        @cancel="close"
        @hidden="close">
        <div class="adminGroupUsersStoreModalWrapper">
            <div class="row">
                <div class="col">
                    <div class="form-group m-form__group mt-3">
                        <input
                            v-model="tag_name"
                            class="form-control m-input"
                            type="text"
                            placeholder="タグを入力してください" />
                        <div v-if="errors.name"
                             class="invalid-feedback d-block">
                            {{ errors.name[0] }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            slot="modal-footer"
            class="w-100" :class="{ 'u-loader u-loader--sm' : inProgress }">
            <button
                class="btn btn-yokumiru-orange float-right"
                :disabled="inProgress"
                @click="handleOk">
                更新
            </button>
            <button
                class="btn btn-yokumiru-gray float-right mr-2"
                :disabled="inProgress"
                @click="close">
                キャンセル
            </button>
        </div>
    </b-modal>
</template>

<script>
    import constants from '../../../../constants'
    import YokumiruHelper from '../../../../YokumiruHelper'

    export default {

        props: {
            group: {
                type: Object,
                required: true,
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
                inProgress: false,
                modalShow: false,
                errors: {},
                tag: {},
                tag_name: "",
            }
        },

        created: function () {
            bus.$on('open-modal-authorizer-management-tags-edit', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-authorizer-management-tags-edit')
        },

        methods: {

            /**
             * モーダル表示
             * @param {object} tag
             */
            open: function (tag) {
                this.tag = {...tag}
                this.tag_name = this.tag.name
                this.modalShow = true
            },

            /**
             * モーダルを閉じる
             */
            close: function () {
                this.errors = {}
                this.modalShow = false
            },

            /**
             * ボタン押下時
             *
             * @param {object} e
             */
            handleOk: function (e) {
                e.preventDefault()
                this.editTag()
            },

            /**
             * 管理用タグ更新
             */
            editTag: async function () {
                if (this.inProgress) return
                this.inProgress = true

                const endpoint = constants.user.groups.endpoint.base

                 axios.put(`${endpoint}/${this.group.id}/groups/tags/${this.tag.id}`, {
                    name: this.tag_name,
                })
                .then(() => {
                    bus.$emit('alert-success', `${ this.tag_name }を更新しました。`)
                    bus.$emit('group-management-tags-edit')
                    this.errors = {}
                    this.close()
                })
                .catch(({response}) => {
                        if (response.hasOwnProperty('data') && response.data.hasOwnProperty('errors')) {
                            bus.$emit('alert-danger')
                            this.errors = response.data.errors
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    })

                this.inProgress = false
                
            },
        },
    }
</script>

<style lang="scss">
.adminGroupUsersStoreModalWrapper {
    .multiselect {
        width: 350px;
    }
}
</style>
